import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { creditPackAsMemberQueryKeys } from "./creditPackAsMemberQueryKeys";

export function useQueryCreditPackListAsMember(
  {
    api,
    opts,
  }: {
    api: ApiType;
    opts: Parameters<ApiType["customerCreditPackApi"]["getList"]>[0];
  },
  {
    enabled,
  }: {
    enabled?: boolean;
  } = {
    enabled: true,
  },
) {
  return useQuery({
    queryKey: creditPackAsMemberQueryKeys.list(opts),
    queryFn: async () => {
      return (await api.customerCreditPackApi.getList({ ...opts })).data;
    },
    enabled,
  });
}
